import React, { useEffect, useState } from 'react';
import { FEATURE_FLAG } from '../../constants/general';
import { canUpgradeToUseFeature, validateFeatureFlag } from '../../services/featureFlagService';
import { trackMixPanel } from '../../services/mixpanel.service';
import { useStore } from '../../store';
import { BillsHub } from './features/BillsHub';
import { Layout } from '../../components/Layout/Layout';
import { BillsFirstImpression } from './features/BillsHub/BillsFirstImpression';

export const BillPay = () => {
  const {
    actionFlags: { billCreated },
  } = useStore((state) => state.summary);
  const resetBillsHubSlices = useStore((state) => state.resetBillsHubSlices);
  const [shouldShowUpgrade] = useState<boolean>(
    canUpgradeToUseFeature(FEATURE_FLAG.BILL_PAY) && !validateFeatureFlag(FEATURE_FLAG.BILL_PAY),
  );

  useEffect(() => {
    trackMixPanel('Act on “Bill pay” menu', { Action: 'Bill Pay' });
    return () => {
      resetBillsHubSlices();
    };
  }, []);

  const renderContent = () => {
    if (shouldShowUpgrade || !billCreated) {
      return (
        <div className='h-full content-around'>
          <BillsFirstImpression />
        </div>
      );
    }

    return <BillsHub />;
  };

  return (
    <Layout wrapperClassName='pt-[78px] pl-[72px] pr-[32px] w-full h-full bg-bw01 overflow-auto ml-[100px] pc-md:ml-[256px]'>
      {renderContent()}
    </Layout>
  );
};
